import { FetchResult } from '@apollo/client'
import { client } from '../../../..'
import { OBJECTIVES_IN_MEETING } from '../../../../graphql/objectives/ObjectiveQuery'
import {
  ObjectiveDistributedAmountInput,
  SaveTargetBonusAmountDistributionMutation,
  SaveTargetBonusAmountDistributionMutationVariables,
} from '../../../../types'
import { SAVE_OBJECTIVES_BONUS_DISTRIBUTION } from './mutations'

export const saveObjectivesBonusDistribution = async (
  inputs: ObjectiveDistributedAmountInput[],
  meetingId: string,
): Promise<FetchResult<SaveTargetBonusAmountDistributionMutation>> => {
  return client.mutate<SaveTargetBonusAmountDistributionMutation, SaveTargetBonusAmountDistributionMutationVariables>({
    mutation: SAVE_OBJECTIVES_BONUS_DISTRIBUTION,
    variables: {
      inputs,
      meetingId,
    },
    refetchQueries: [
      {
        query: OBJECTIVES_IN_MEETING,
        variables: {
          meetingId,
        },
      },
    ],
  })
}
